import { GzDynamicFormWrapperWebComponent } from './component/GzDynamicFormWrapperWebComponent';
import {
  WEB_COMPONENT_GZ_DYNAMIC_FORM_WRAPPER,
  WEB_COMPONENT_GZ_DYNAMIC_FORM_INPUT,
} from '../../webcomponents.constants';
import { GzDynamicFormInputWebComponent } from './component/GzDynamicFormInput';

export { GzDynamicFormWrapperWebComponent, GzDynamicFormInputWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_DYNAMIC_FORM_WRAPPER, GzDynamicFormWrapperWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_DYNAMIC_FORM_INPUT, GzDynamicFormInputWebComponent);
